var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBurgerMenu5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m11 7c0-.55228.4477-1 1-1h7c.5523 0 1 .44772 1 1s-.4477 1-1 1h-7c-.5523 0-1-.44772-1-1zm-7 5c0-.5523.44772-1 1-1h14c.5523 0 1 .4477 1 1s-.4477 1-1 1h-14c-.55228 0-1-.4477-1-1zm0 5c0-.5523.44772-1 1-1h7c.5523 0 1 .4477 1 1s-.4477 1-1 1h-7c-.55228 0-1-.4477-1-1z",
    fill: "black",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurgerMenu5);
export default __webpack_public_path__ + "static/media/burger-menu-5.9fcba4d76d1c886d1f0cf3ccc6de9071.svg";
export { ForwardRef as ReactComponent };